import { UserType } from '@nemuru-eng/js-api-client';

import { teslaMerchantChannelAgentNavMenu } from '@/components/views/DynamicPageView/config/layoutScheme/navMenuSchemes/defaultNavMenu';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { Layout, NavSection } from '@/config/types';
import { UserEntity } from '@/entities/UserEntity';

export const isTeslaMerchantChannelAgent = (userEntity: UserEntity, teslaMerchantIds: readonly string[]): boolean =>
  !!userEntity.merchant &&
  teslaMerchantIds.includes(userEntity.merchant.id) &&
  userEntity.hasUserType([UserType.MERCHANT, UserType.CHANNEL, UserType.AGENT]);

export const getClonedTeslaMerchantChannelAgentNavMenu = (): NavSection[] =>
  teslaMerchantChannelAgentNavMenu.map((section) => ({
    ...section,
    links: section.links.map((link) => ({ ...link })),
  }));

export const removePagesFromTeslaLayout = (
  layout: Layout,
  merchantId: string,
  teslaMerchantIds: readonly string[],
): void => {
  if (!teslaMerchantIds.includes(merchantId)) return;

  delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.APPLICATION];
  delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.SIMULATOR];
  delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.MERCHANT_LIST];
  delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.PRICINGS_LIST];
  delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.INTEGRATIONS];
  delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.USERS];
  delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.PAYOUTS_LIST];
  delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.REPORTS_LIST];
};
